var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('data-table',{attrs:{"headers":_vm.headers,"data":_vm.data,"loading":_vm.loading,"options":_vm.options}},[_c(_vm.headerChildComponent,{tag:"component",attrs:{"refreshData":_vm.getPlans}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }